import checkoutActions from "./actions";
import { put, all, call, takeEvery, select } from "redux-saga/effects";
import {
  API_URL,
  BILLING_EMAIL,
  CCAVANUE_PAYMENT_GATEWAY_REDIRECT_URL,
  CCAVANUE_TEST_ACCESS_CODE,
  TARGET_APP,
} from "../../utils/constant";
import axios from "axios";
import { DecryptFunction, EncryptFunction } from "../../utils/cryptoFunction";
import moment from "moment-timezone";
import commonActions from "../common/actions";

const checkoutSagas = function* () {
  yield all([
    yield takeEvery(
      checkoutActions.GET_DELIVERY_TYPE_LIST,
      getDeliveryTypeList
    ),
    yield takeEvery(checkoutActions.CALCUATE_GST, calculateGST),
    yield takeEvery(checkoutActions.CALCULATE_SHIPPING, calculateShipping),
    yield takeEvery(checkoutActions.CREATE_NEW_ORDER, createNewOrder),
    yield takeEvery(checkoutActions.CREATE_ORDER_NUMBER, createOrderNumber),
    yield takeEvery(checkoutActions.PAYMENT_ENCODER, paymentEncoder),
    yield takeEvery(checkoutActions.PAYMENT_DECODER, paymentDecoder),
    yield takeEvery(checkoutActions.PAYMENT_VERIFY_COD, paymentVerifyCod),
    yield takeEvery(checkoutActions.UPDATE_USER_COUPON, updateUserCoupon),
    yield takeEvery(checkoutActions.APPLY_ORDER_COUPON, applyOrderCoupon),
    yield takeEvery(checkoutActions.PAYMENT_VERIFY_ONLINE, paymentVerifyOnline),
    yield takeEvery(
      checkoutActions.CCAVENUE_PAYMENT_GATEWAY,
      ccavanuePaymentGateway
    ), //chech-1
    yield takeEvery(
      checkoutActions.PHONEPE_PAYMENT_ENCODER,
      encodePhonepeRequest
    ),
    yield takeEvery(checkoutActions.INII_PHONEPE_INTENT, initiatePhonepe),
    yield takeEvery(checkoutActions.GET_PAYMENT_TYPE_LIST, getPaymentTypes),

  ]);
};

const getDeliveryTypeList = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/v1/user/shippingproviders`)
    );

    if (result?.data?.code === 200) {
      const uniqueSet = new Set();

      const uniqueArray = result?.data?.data.filter((item) => {

        const key = `${item.shipping_type}-${item.delivery_range}`;
        if (!uniqueSet.has(key)) {
          uniqueSet.add(key);
          return true;
        }
        return false;
      });

      yield put({
        type: checkoutActions.SET_DELIVERY_TYPE_LIST,
        payload: uniqueArray,
      });
    }
  } catch (err) {
    console.log(err);
  }
};

const calculateGST = function* () {
  try {
    const { cartProducts } = yield select((state) => state.cartReducer);
    const { checkoutValues, deliveryType } = yield select(
      (state) => state.checkoutReducer
    );

    const { userAddress } = yield select((state) => state.userReducer);
    if (cartProducts && cartProducts?.order_items?.length > 0) {

      let priceObj = {
        amount: 0,
        discount: 0,
        total: 0,
        package_weight_in_gram: 0,
      };

      cartProducts?.order_items?.map((val) => {
        let product_rate = parseFloat(val?.rate) * parseInt(val?.quantity);
        priceObj["amount"] =
          parseFloat(priceObj["amount"]) + parseFloat(product_rate);
        let product_dis = parseFloat(val?.discount) * parseInt(val?.quantity);
        priceObj["discount"] =
          parseFloat(priceObj["discount"]) + parseFloat(product_dis);
        let weight =
          parseFloat(val?.package_weight_in_gram) * parseInt(val?.quantity);
        priceObj["package_weight_in_gram"] =
          parseFloat(priceObj["package_weight_in_gram"]) + parseFloat(weight);
      });
      priceObj["total"] = priceObj["amount"] - priceObj["discount"];
      let coupon_discount = checkoutValues?.coupon_discount || 0;
      let shipping_charges = checkoutValues?.shippingCharge || 0;
      const total = priceObj["total"] - coupon_discount - shipping_charges;

      const wight_in_kg = priceObj["package_weight_in_gram"] / 1000;
      const { initialPayment } = yield select((state) => state.checkoutReducer);
      yield put({
        type: checkoutActions.CHECKOUT_VALUES,
        payload: {
          ...checkoutValues,
          DeliveryAddress:
            userAddress?.length > 0 &&
              userAddress?.find((val) => val.default_address === 1)
              ? userAddress?.find((val) => val.default_address === 1)
              : userAddress[0],
          DeliveryType:
            deliveryType?.length > 0 &&
            deliveryType?.find((val) => val?.shipping_type === "Express"),
          PaymentType: initialPayment.payment_Type,
          product_amount: priceObj?.amount,
          discount: priceObj?.discount,
          total: total,
          wight_in_kg: wight_in_kg,
        },
      });
      if (
        checkoutValues?.DeliveryAddress?.state &&
        checkoutValues?.DeliveryType?.id
      ) {
        yield put({
          type: checkoutActions.CALCULATE_SHIPPING,
          payload: {
            weight_kg: wight_in_kg,
            state: checkoutValues?.DeliveryAddress?.state,
            provider_id: checkoutValues?.DeliveryType?.id,
            order_value: total,
            shipping_type: checkoutValues?.DeliveryType?.shipping_type,
          },
        });
      }
    }
  } catch (err) {
    console.log(err);
  }
};

const calculateShipping = function* (data) {
  const { payload } = data;

  const { checkoutValues } = yield select((state) => state.checkoutReducer);
  try {
    const { cartProducts } = yield select((state) => state.cartReducer);

    const result = yield call(() =>
      axios.post(`${API_URL}/v1/user/shippingcharges`, payload)
    );


    if (result?.data?.code === 200) {
      const gstPercentage = parseFloat(cartProducts?.order_items[0]?.gst);
      let priceObj = { amount: 0, discount: 0, total: 0 };
      //eslint-disable-next-line
      cartProducts?.order_items?.map((val) => {
        let product_rate = parseFloat(val?.rate) * parseInt(val?.quantity);
        priceObj["amount"] =
          parseFloat(priceObj["amount"]) + parseFloat(product_rate);
        let product_dis = parseFloat(val?.discount) * parseInt(val?.quantity);
        priceObj["discount"] =
          parseFloat(priceObj["discount"]) + parseFloat(product_dis);
      });
      priceObj["total"] = priceObj["amount"] - priceObj["discount"];
      let coupon_discount = checkoutValues?.coupon_discount || 0;

      const discountedPrice = priceObj["total"] - coupon_discount;
      const total = discountedPrice;
      let finalTotal = parseFloat(total),
        shippingCharge = 0;
      if (result?.data?.data?.rate) {
        if (checkoutValues?.PaymentType === 0) {
          if (
            parseFloat(checkoutValues?.product_amount) >=
            parseFloat(checkoutActions?.DeliveryType?.free_shipping)
          ) {

            finalTotal = parseFloat(total);
            shippingCharge = parseFloat(0);
          } else {

            finalTotal =
              parseFloat(total) + parseFloat(result?.data?.data?.rate);

            shippingCharge = parseFloat(result?.data?.data?.rate);
          }
        } else {
          if (
            parseFloat(checkoutValues?.product_amount) >=
            parseFloat(checkoutValues?.DeliveryType?.free_shipping)
          ) {

            finalTotal = parseFloat(total);
            shippingCharge = parseFloat(0);
          } else {
            finalTotal =
              parseFloat(total) + parseFloat(result?.data?.data?.rate);
            shippingCharge = parseFloat(result?.data?.data?.rate);
          }
        }
      }

      yield put({
        type: checkoutActions.CHECKOUT_VALUES,
        payload: {
          ...checkoutValues,
          total: finalTotal,
          shippingCharge: shippingCharge,
          shippingChanges: result?.data?.data,
        },
      });


    }
  } catch (err) {
    console.log(err);
  }
  // }
};

const createNewOrder = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  try {
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
    const result = yield call(() =>
      axios.put(`${API_URL}/v1/user/neworder`, payload?.data)
    );

    if (result?.data?.code === 200) {
      yield put({
        type: checkoutActions.CREATE_ORDER_NUMBER,
        payload: {
          data: {
            id: result?.data?.data[0]?.id,
            amount: payload?.data?.total_amount,
          },
          payment_type: payload?.data?.payment_type,
          navigate: navigate,
        },
      });
    }
  } catch (err) {
    console.log(err);
  }
};

const createOrderNumber = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment`, payload?.data)
    );

    const { checkoutValues } = yield select((state) => state.checkoutReducer);
    const EncryptData = EncryptFunction(checkoutValues?.toString());
    sessionStorage.setItem("checkout_status", EncryptData);
    const User = localStorage.getItem("auth_user");
    const user_id = DecryptFunction(User);
    if (result?.data?.code === 200) {
      if (checkoutValues?.applied_Coupon?.discount_type === 1) {
        yield put({
          type: checkoutActions.APPLY_ORDER_COUPON,
          payload: {
            id: payload?.data?.id,
            coupon_percentage: checkoutValues?.applied_Coupon?.discount,
          },
        });
      }
      if (payload?.payment_type === 0) {
        yield put({
          type: checkoutActions.PAYMENT_VERIFY_COD,
          payload: {
            data: {
              orderId: result?.data?.data?.id,
              status: "PENDING",
            },
            navigate: navigate,
          },
        });
      } else if (payload?.payment_type === 2) {
        if (user_id) {
          if (checkoutValues?.applied_Coupon) {
            yield put({ type: checkoutActions.UPDATE_USER_COUPON });
          }
          const { UserProfile } = yield select((state) => state.AuthReducer);

          yield put({
            type: checkoutActions.PHONEPE_PAYMENT_ENCODER,
            payload: {
              merchantTransactionId: payload?.data?.id,
              amount: parseInt(parseFloat(checkoutValues?.total)?.toFixed(0)),
              mobile_no: UserProfile?.mobile_no,
              name: UserProfile?.name,
              merchantUserId: `MUID${UserProfile?.id}`,
            },
          });
        }
      } else {
        if (user_id) {
          if (checkoutValues?.applied_Coupon) {
            yield put({ type: checkoutActions.UPDATE_USER_COUPON });
          }
          const { UserProfile } = yield select((state) => state.AuthReducer);
          yield put({
            type: checkoutActions.PAYMENT_ENCODER,
            payload: {
              data: {
                amount: parseInt(parseFloat(checkoutValues?.total)?.toFixed(0)),
                billing_name: UserProfile?.name,
                billing_address: checkoutValues?.DeliveryAddress?.address_line3,
                billing_city: checkoutValues?.DeliveryAddress?.city,
                billing_state: checkoutValues?.DeliveryAddress?.state,
                billing_zip: checkoutValues?.DeliveryAddress?.pincode,
                billing_country: checkoutValues?.DeliveryAddress?.country,
                billing_tel: UserProfile?.mobile_no,
                billing_email: UserProfile?.email
                  ? UserProfile?.email
                  : BILLING_EMAIL,

                delivery_name: UserProfile?.name,
                delivery_tel: UserProfile?.mobile_no,
                delivery_address:
                  checkoutValues?.DeliveryAddress?.address_line3,
                delivery_city: checkoutValues?.DeliveryAddress?.city,
                delivery_state: checkoutValues?.DeliveryAddress?.state,
                delivery_zip: checkoutValues?.DeliveryAddress?.pincode,
                delivery_country: checkoutValues?.DeliveryAddress?.country,
                currency: "INR",
                language: "EN",
                order_id: payload?.data?.id,
                merchant_param1: "YOURFARM",

                redirect_url: `${API_URL}/v1/payment/verify`,
                cancel_url: `${API_URL}/v1/payment/verify`,
              },
              navigate: navigate,
            },
          });
        }
      }
    }
  } catch (err) {
    console.log(err);
  }
};

const paymentEncoder = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment/encorder`, payload?.data)
    );
    if (result?.data?.code === 200) {
      yield put({
        type: checkoutActions.CCAVENUE_PAYMENT_GATEWAY,
        payload: { data: result?.data?.data, navigate: navigate },
      });
    }
  } catch (err) {
    console.log(err);
  }
};

const paymentDecoder = function* (data) {
  const { payload } = data;

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment/decorder`, payload)
    );
    yield put({
      type: checkoutActions.DECODER_RESPONSE,
      payload: result?.data,
    });

  } catch (err) {
    console.log(err);
  }
};

const updateUserCoupon = function* () {
  try {
    const { checkoutValues } = yield select((state) => state.checkoutReducer);
    const userMobile = DecryptFunction(localStorage.getItem("auth_user_no"));
    const User = DecryptFunction(localStorage.getItem("auth_user"));
    if (checkoutValues?.applied_Coupon?.id) {
      const userId = DecryptFunction(User);
      const mobile_no = DecryptFunction(userMobile);
      if (userId && mobile_no) {
        const payloadData = {
          coupon_id: checkoutValues?.applied_Coupon?.id,
          redemption_user_id: userId,
          redemption_date: moment().format("YYYY-MM-DD"),
          mobile_no: mobile_no?.toString(),
        };
        yield call(() =>
          axios.put(
            `${API_URL}/v1/user/coupon_redemptions/${userId}`,
            payloadData
          )
        );

      }
    }
  } catch (err) {
    console.log(err);
  }
};

const applyOrderCoupon = function* (data) {
  const { payload } = data;

  try {
    yield call(() => axios.put(`${API_URL}/v1/user/orders/coupon`, payload));
  } catch (err) {
    console.log(err);
  }
};

const paymentVerifyCod = function* (data) {
  const { payload } = data;
  const { navigate } = payload;

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment/verify/cod`, payload?.data)
    );
    if (result?.data?.success === "true") {
      const { checkoutValues } = yield select((state) => state.checkoutReducer);
      if (checkoutValues?.applied_Coupon) {
        yield put({ type: checkoutActions.UPDATE_USER_COUPON });

      }
      navigate("/PaymentSuccess");

    } else {
      navigate("/PaymentFailed");

    }
  } catch (err) {
    console.log(err);
  }
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
};

const paymentVerifyOnline = function* () {
  try {
    yield call(() => axios.post(`${API_URL}/v1/payment/verify`));
  } catch (err) {
    console.log(err);
  }
};

const ccavanuePaymentGateway = function* (data) {
  const { payload } = data;
  const { navigate } = payload;
  try {
    let web_url = CCAVANUE_PAYMENT_GATEWAY_REDIRECT_URL;

    let accces = CCAVANUE_TEST_ACCESS_CODE;

    var html =
      `<html> <head><meta name='viewport' content='width=device-width, initial-scale=1.0'></head> 
            <body onload='document.f.submit();'> <form id='f' name='f' method='post' action='${web_url}?command=initiateTransaction'>` +

      `<input type='hidden' name='encRequest' value='${payload?.data}'/>` +
      `<input  type='hidden' name='access_code' value='${accces}'/></form></body></html>`;

    yield put({
      type: checkoutActions.INITIATE_CCAVENUE_TRANSACTION_SUCCESS,
      payload: html,
    });

    navigate("/payment-gateway");

  } catch (err) {
    console.log(err);
  }
};

const encodePhonepeRequest = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment/phonepe/encrequest`, payload)
    );


    if (result?.data.code === 200) {
      const params = {
        amount: payload.amount,
        mobile_no: payload.mobile_no,
        name: payload.name,
        order_id: payload.merchantTransactionId,
        instrument_type: "PAY_PAGE",
        target_app: TARGET_APP,
      };
      yield put({
        type: checkoutActions.INII_PHONEPE_INTENT,
        payload: params,
      });
    }
  } catch (err) {
    console.log("encodePhonepe", err);
  }
};

const initiatePhonepe = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/v1/payment/phonepe`, payload)
    );

    if (result?.data?.code === 200) {
      const url = result?.data?.data[0]?.redirectInfo?.url;
      window.location.href = url;
    }
  } catch (err) {
    console.log("initiatePhonepe", err);
  }
};

const getPaymentTypes = function* () {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/v1/admin/status/type/payment`)
    );
    if (result.status === 200) {
      yield put({
        type: checkoutActions.SET_PAYMENT_TYPE_LIST,
        payload: result?.data?.data,
      });
    }
  } catch (err) {
    console.log("getPaymentTypes err", err);
  }
};



export default checkoutSagas;
